import { Button, Center, Select } from "@mantine/core";
import { modals } from "@mantine/modals";
import SRD_Form from "components/Form";
import { useEffect, useState } from "react";
import { copyDeviceObjectList, getDevicesInField } from "../apis/adminSiteEditApis";

function CopyDeviceObject(props) {
    const {
      group_id,
      field_id,
      deviceList,
      fieldList,
    } = props;
    const [selectedField, setSelectedField] = useState();
    const [deviceInSelectedField,setDeviceInSelectedField] = useState([]);
    const [targetField, setTargetField] = useState(field_id);
    const  objWidth = [
      {label: "1/1", value: 1600},
      {label: "1/2", value: 800},
      {label: "1/3", value: 533},
      {label: "1/4", value: 400},
      {label: "1/5", value: 320},
    ];

    const leftOffset = [
        {label: "1/n", value: 0 },
        {label: "2/5", value: 320 },
        {label: "2/4", value: 400 },
        {label: "2/3", value: 533 },
        {label: "2/2", value: 800 },
        {label: "3/5", value: 640 },
        {label: "3/4", value: 800 },
        {label: "3/3", value: 1066 },
        {label: "4/5", value: 960 },
        {label: "4/4", value: 1200 },
        {label: "5/5", value: 1280 },
    ];

    useEffect(() => {
      if (selectedField) {
        getDevicesInField(selectedField)
        .then(res => setDeviceInSelectedField(res));
      }
    },[selectedField]);

    const SelectedOriginField = (props) => {
      const { field, name } = props;
      setSelectedField(field.value);
      return (
        <Select
          label={name}
          data={fieldList}
          value={field.value}
          placeholder={name}
          {...field}
        />
      );
    };

    const SelectedTargetField = (props) => {
      const { field, name } = props;
      return (
        <Select
          label={name}
          data={fieldList}
          value={targetField}
          onChange={(value) => setTargetField(value)}
          placeholder={name}
          {...field}
        />
      );
    };

    const fields = [
        {
          key: "source_field_id",
          name: "복사할 장치가 있는 현장명(source)",
          type: "etc",
    //      options: "validate"
          component:SelectedOriginField,
          show: true,
        },
        {
          key: "target_field_id",
          name: "복사 대상 현장명(target)",
          type: "etc",
          component: SelectedTargetField,
          show: true,
        },
        {
          key: "source_id",
          name: "장치명(source)",
          type: "select",
          options: deviceInSelectedField ?? "",
          show: true,
        },
        {
          key: "src_left_offset",
          name: "복사대상 시작 위치(Source): (예)화면에 4개의장치를 표시할때 2번째는 2/4)",
          type: "select",
          options:leftOffset,
          show: true,
        },
        {
          key: "width",
          name: "복사 범위(넓이): (예)2번쨰 장치를 복사할 때 넓이가 1/4이면 2번째 장치위치부터 화면의 1/4범위의 폭에 존재하는 오브젝트 모두를 복사함)",
          type: "select",
          options:objWidth,
          show: true,
        },
        {
          key: "destination_id",
          name: "장치명(destination)",
          type: "select",
          options: deviceList,
          show: true,
        },    
        {
          key: "nm_prefix",
          name: "채널명 접두어(숫자를 접두어로 사용하지 마세요 !!)",
          type: "text",
          show: true,
        }, 
        {
          key: "nm_suffix",
          name: "채널명 접미어",
          type: "text",
          show: true,
        },
        {
          key: "dest_left_offset",
          name: "복사된 오브젝트 시작 위치(Destination): (예)화면에 4개의 장치를 표시할때 2번째는 2/4)",
          type: "select",
          options:leftOffset,
          show: true,
        },
    ];
    

    const onSubmit = (e) => {
        modals.openConfirmModal({
          title: "저장",
          children: <Center>선택한 장치의 전체 오브젝트를 복사 하시겠습니까?</Center>,
       //   centered: true,
          zIndex: 2050,
          labels: { confirm: "복사", cancel: "취소" },
          onConfirm: () => {
            if (group_id && targetField) {
              copyDeviceObjectList(e, targetField, group_id)
              .then(res => {
                alert(res);
              });
            }
     //       navigate("/admin/site_edit");
          },
        });
    };
    
    const SubmitButton = () => {
        return (
          <Center style={{ marginTop: "1rem" }}>
            <Button type="submit">장치 오브젝트 복사</Button>
          </Center>
        );
    };
    
    return (
      <div style={{ width: "100%", height: "800px"}}>
          <SRD_Form fields={fields} onSubmit={onSubmit} submitButton={<SubmitButton />} />
      </div>
    );
}

export default CopyDeviceObject;